export interface ACarouselAdditionalBoxInfo {
    BoxId: number;
    IconInfo: ICarouselIconInfo;
    RelatedItemId?: string;
}

export interface ICarouselIconInfo {
    Info: CarouselInfoEnum;
}

export enum CarouselInfoEnum {
    MissingPurchaseDate = 1,
    /** Unconfirmed slaughter or intermediation announcement */
    UnconfirmedPreliminaryAnnouncement = 2,
    UnconfirmedPreliminaryBovinePurchaseAnnouncement = 3,
}
